/*
  Bebottiglie: finestra della griglia Instagram (SCOPE S41).

  I riquadri con un video caricato su Shopify aprono la finestra e lo
  riproducono qui, con la didascalia di fianco. Gli altri restano collegamenti
  normali verso Instagram.

  L'incorporamento ufficiale di Instagram e' stato provato e scartato il
  26/08/2026: senza una sessione Instagram nel browser risponde "il link e'
  rotto" oppure una scheda bianca. Con i video ospitati da noi la galleria
  funziona per chiunque e nessun dato del visitatore arriva a Meta.
*/

(function () {
  if (window.bbInstagramReady) return;
  window.bbInstagramReady = true;

  function hostOf(modal) {
    return modal.querySelector('[data-bb-ig-host]');
  }

  function open(tile, modal) {
    const host = hostOf(modal);
    const player = tile.querySelector('template');
    if (!player) return false;

    host.replaceChildren(player.content.cloneNode(true));
    modal.showModal();

    const video = host.querySelector('video');
    if (video) video.play().catch(function () {});

    modal.addEventListener('close', function () {
      const playing = host.querySelector('video');
      if (playing) playing.pause();
      host.replaceChildren();
    }, { once: true });

    return true;
  }

  document.addEventListener('click', function (event) {
    const tile = event.target.closest('.bb-ig__item[data-bb-ig-player]');

    if (tile) {
      const grid = tile.closest('.bb-ig');
      const modal = grid && document.getElementById(grid.dataset.bbIgModal);
      if (!modal || typeof modal.showModal !== 'function' || !hostOf(modal)) return;

      // Se il video non parte, il clic resta quello che era: apre il post.
      if (open(tile, modal)) event.preventDefault();
      return;
    }

    const modal = event.target.closest('.bb-ig-modal');
    if (!modal) return;

    // Un clic che arriva fino a <dialog> senza toccare il contenuto viene dallo
    // sfondo: si chiude.
    if (event.target === modal || event.target.closest('.bb-ig-modal__close')) {
      modal.close();
    }
  });
})();
